import uuid from 'uuid/v1';

const getId = () => {
  return `tmp-${uuid()}`;
};

const updateAmountOnItem = (itemToUpdate, amount) => {
  itemToUpdate.Amount = amount;
  itemToUpdate.Pending = true;
};

// When the dealMap is passed to us we need to create modifiable arrays so that we don't modify the
// original arrays. The user MAY pass us safe arrays but it is more likely the developer will pass
// the arrays by reference and this prevents weird bugs from emerging. Some of the arrays might be
// null as well and this prevents that.
const getDealComponentsSafe = dealMap => {
  // if the deals that were passed to us are a reference we create a new array to prevent bugs.
  // if the deals are null we create an empty array
  const deals = dealMap.deals ? [...dealMap.deals] : [];
  const dealTransactions = dealMap.dealTransactions
    ? [...dealMap.dealTransactions]
    : [];
  const dtvts = dealMap.dtvts ? [...dealMap.dtvts] : [];
  const voucherTransactions = dealMap.voucherTransactions
    ? [...dealMap.voucherTransactions]
    : [];
  const vouchers = dealMap.vouchers ? [...dealMap.vouchers] : [];

  return {
    deals,
    dealTransactions,
    dtvts,
    voucherTransactions,
    vouchers,
  };
};

export { updateAmountOnItem, getDealComponentsSafe, getId };
